import { defineStore } from 'pinia';

export const useMyOhcStore = defineStore('myOhc', {
  state: () => ({
    myOhcLinks: [
      {
        name: 'My Favorites',
        url: '/my-ohc/',
        children: [
          {
            name: 'Sites',
            url: '/my-ohc/',
          },
          {
            name: 'OHC Itineraries',
            url: '/my-ohc/site-tours/',
          },
          {
            name: 'Events',
            url: '/my-ohc/events/',
          },
        ],
      },
      {
        name: 'My Itineraries',
        url: '/my-ohc/itineraries/',
        children: [],
      },
    ],
  }),

  getters: {
    getSitesData({ myOhcLinks }) {
      if (myOhcLinks !== null) {
        return myOhcLinks;
      }
    },
  },
});
